import { makeVar } from '@apollo/client';
import { CurrentUserProfile } from 'common/graphql/__generated__/CurrentUserProfile';
import { nodeMapType } from 'documents/documentAssignment/folder/list/utils';
import { UserDefaults_userDefaults_nodes } from 'Preferences/__generated__/UserDefaults';
import { storedDarkMode } from 'utility/localStorage';

export const darkMode = makeVar<boolean>(storedDarkMode());
export const expandedNav = makeVar<boolean>(true);
export const globalMode = makeVar<boolean>(false);
export const highlightTextMode = makeVar<boolean>(true);
export const setGlobalSearchText = makeVar<string>('');
export const setUserPrivileges = makeVar<Set<string>>(new Set<string>());
export const setUserDefaults = makeVar<
  UserDefaults_userDefaults_nodes | undefined
>(undefined);
export const setCurrentProfile = makeVar<CurrentUserProfile | undefined>(
  undefined
);
export const closeOpenedDocument = makeVar<boolean>(false);
export const setActiveOrderIndex = makeVar<
  Map<number, { orderNumber: number; layerNumber: number }>
>(new Map<number, { orderNumber: number; layerNumber: number }>());
export const isDashBoardScreen = makeVar<boolean>(false);
// below reactive var is used to keep cache data for currently selected document in Document assignment view
export const setActivePoolDocument = makeVar<nodeMapType | undefined>(
  undefined
);

export const setTripInitiateFlow = makeVar<
  'none' | 'initiated' | 'in-progress' | 'ready'
>('none');
export const isFilteredTripListVar = makeVar<boolean>(false);
export const travelerDialogVisibleVar = makeVar<string | undefined>(undefined);
export const chartFetchTimestampsVar = makeVar<Record<string, number>>({});
export const shouldPollNotificationQuery = makeVar<boolean>(true);
export const lastActivityTimestamp = makeVar<number>(Date.now());
